import React, { useCallback, useEffect, useState } from 'react';

import { Sidebar } from 'components/layout/SideBar';
import LayoutContent from 'components/layout/content/LayoutContent';
import MobileTopBar from 'components/layout/headers/MobileTopBar';

interface AdaptiveLayoutShellProps {
  children?: React.ReactNode;
  isMobile: boolean;
  isFullWidthRoute: boolean;
  isCollapsed: boolean;
  onToggleCollapsed: () => void;
  path: string;
  title: string;
  mobileTitle?: string;
}

const AdaptiveLayoutShell = ({
  children = undefined,
  isMobile,
  isFullWidthRoute,
  isCollapsed,
  onToggleCollapsed,
  path,
  title,
  mobileTitle,
}: AdaptiveLayoutShellProps) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleOpen = useCallback(() => setMobileOpen(true), []);
  const handleClose = useCallback(() => setMobileOpen(false), []);

  useEffect(() => {
    setMobileOpen(false);
  }, [path]);

  return (
    <>
      {isMobile && <MobileTopBar title={mobileTitle ?? title} onOpenMenu={handleOpen} />}
      <Sidebar
        variant={isMobile ? 'temporary' : 'permanent'}
        open={isMobile ? mobileOpen : true}
        onClose={handleClose}
        isCollapsed={isMobile ? false : isCollapsed}
        onToggleCollapsed={onToggleCollapsed}
      />
      <LayoutContent isMobile={isMobile} isCollapsed={isCollapsed} isFullWidthRoute={isFullWidthRoute}>
        {children}
      </LayoutContent>
    </>
  );
};

export default AdaptiveLayoutShell;
